import { createClient } from "@sanity/client";

const projectId =
  process.env.REACT_APP_SANITY_PROJECT_ID || "5kurhfw4";

const dataset =
  process.env.REACT_APP_SANITY_DATASET || "lesson-redesign-test";

const apiVersion =
  process.env.REACT_APP_SANITY_API_VERSION || "2024-01-01";

/*
 * For the redesign test, keep CDN off so newly published Sanity
 * content appears immediately while we test.
 */
const useCdn =
  String(process.env.REACT_APP_SANITY_USE_CDN || "false").toLowerCase() ===
  "true";

export const sanityClient = createClient({
  projectId,
  dataset,
  apiVersion,
  useCdn,
});

console.log("[Sanity] frontend client:", {
  projectId,
  dataset,
  apiVersion,
  useCdn,
});